const DEFAULT_API_BASE_URL = 'https://dev-api.shiftwagon.co.za/shiftwagon/';

function ensureTrailingSlash(value: string): string {
  return value.endsWith('/') ? value : `${value}/`;
}

export function buildApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return new URL(normalizedPath, API_BASE_URL).toString();
}

export const API_BASE_URL = ensureTrailingSlash(
  (import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL).trim(),
);

export const DRIVER_SELF_SERVICE_ONBOARDING_ENABLED =
  String(import.meta.env.VITE_DRIVER_SELF_SERVICE_ONBOARDING_ENABLED ?? 'false').toLowerCase() === 'true';

/**
 * Web booking and tracking — ON by default as of Phase E.
 *
 * The flag existed so the build could land in `main` in reviewable pieces
 * without the marketing site promising a flow that could not complete. That
 * journey now works end to end, so the default flips and the site's copy has
 * been corrected to match — see docs/ux-alignment/02-web-booking-discovery.md.
 *
 * DEFAULTING TO TRUE IS THE POINT, not a shortcut. `.env` is gitignored, so
 * while the default was `false` every build from a clean checkout — CI, and
 * production — silently shipped with booking off no matter what a developer
 * had locally. The default is the value that actually ships; anything else
 * makes the deployed behaviour depend on an untracked file.
 *
 * Set VITE_WEB_BOOKING_ENABLED=false to turn the customer area back off. That
 * kills booking, /account and live tracking together, and reverts the header
 * and estimate widget to pointing at the app.
 */
export const WEB_BOOKING_ENABLED =
  String(import.meta.env.VITE_WEB_BOOKING_ENABLED ?? 'true').toLowerCase() === 'true';

export const PUBLIC_WHATSAPP_NUMBER = String(
  import.meta.env.VITE_PUBLIC_WHATSAPP_NUMBER ?? '',
).replace(/[^\d]/g, '');

export const PUBLIC_WHATSAPP_DEFAULT_MESSAGE = String(
  import.meta.env.VITE_PUBLIC_WHATSAPP_DEFAULT_MESSAGE ?? 'Hi, I want to book a bakkie',
).trim();
